// extracted by mini-css-extract-plugin
export var cartIcon = "_mg-0";
export var cartIconContainer = "_mg-1";